import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
  ImageTitle,
} from './styled';

const Security = () => {
  const { messages, locale } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id="home.security.title" />
          </Title>
          <Subtitle>
            <FormattedMessage id="home.security.paragraph" />
          </Subtitle>
        </Contentwrapper>
        <ImageWrapper>
          <ImageTitle>Security</ImageTitle>
          <StyledImage
            src={messages['home.security.image.src']}
            alt={messages['home.security.image.alt']}
          />
        </ImageWrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default Security;
